import { AlertCircle, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import Typography from "@/components/ui/typography";

const IcpPrompt = () => {
  const navigate = useNavigate();

  return (
    <div className="rounded-2xl border border-sds-yellow-40 bg-sds-yellow-20 p-6 sm:p-8">
      <div className="flex flex-col sm:flex-row items-start gap-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-sds-yellow-40 flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-sds-yellow-100" />
        </div>

        <div className="flex-1">
          <Typography size="l2" className="font-semibold text-[#1e1e24] mb-1">
            Complete your ICP to unlock AI Lead Finder
          </Typography>
          <Typography size="b2" className="text-[#767677] mb-4">
            We need your niche and ideal customer profile (ICP) to generate
            targeted leads. Head to your settings to define who you serve and
            what you offer.
          </Typography>

          <Button
            variant="ghost"
            className="h-9 rounded-lg px-5 border border-[#e8e8e8] text-[#1e1e24] hover:bg-transparent"
            onClick={() => navigate("/founder/settings")}
          >
            Go to Settings <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default IcpPrompt;
